import './scss/index.scss';
import { dcFactory } from 'dc';
import { AccountSelectorComponent } from './js/account-selector.component';

dcFactory.register(AccountSelectorComponent);
